import { Box, Stack } from "@mui/material";
import { FormType } from "@simplyk/common";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
import { useMediaQuery } from "@/common/hooks/useMediaQuery";

type AuctionSummaryLayoutProps = {
  slots: {
    banner?: React.ReactNode;
    organizationLogo: React.ReactNode;
    coreInfo?: React.ReactNode;
    campaignTarget?: React.ReactNode;
    description?: React.ReactNode;
    divider?: React.ReactNode;
  };
};

export const AuctionSummaryLayout = ({ slots }: AuctionSummaryLayoutProps) => {
  const { isSmallScreen } = useMediaQuery();
  const { isEmbed } = useFormV2Context(FormType.Ticketing);

  return (
    <Stack width="100%" direction="column" alignItems="flex-start" gap={2}>
      {!isSmallScreen && slots.banner && <Box sx={{ marginBlockEnd: 1, width: "100%" }}>{slots.banner}</Box>}
      {slots.organizationLogo}
      {!isSmallScreen && !isEmbed && slots.divider}
      {isSmallScreen && slots.coreInfo}
      {slots.campaignTarget}
      {!isEmbed && slots.description}
    </Stack>
  );
};
